import { NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { TranslateModule } from '@ngx-translate/core';
import { GeoCoordinates } from '@sc/data-access-models';
import { TranslatorService } from '@sc/data-access-translation';
import { IconComponent } from '@sc/ui-components';

@Component({
  selector: 'sc-chose-new-address-bottom-sheet',
  styleUrls: ['./chose-new-address-bottom-sheet.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, MatDividerModule, NgIf, TranslateModule],
  template: `
    <div class="content" fxLayout="column">
      <section>
        <button
          class="sc-design-text-3 section-bloc new-address-link"
          (click)="onChoseNewAddress()"
        >
          <sc-icon
            name="more"
            specificName="chose-new-address-bottom-sheet-calendar"
          ></sc-icon>
          <span>{{ 'ChoseNewAddressBottomSheet.newaddress' | translate }}</span>
        </button>
      </section>

      <mat-divider></mat-divider>
      <section>
        <button
          [title]="
            ('ChoseNewAddressBottomSheet.currentLocation' | translate) +
            ' - ' +
            ('ChoseNewAddressBottomSheet.enableGeolocHint' | translate)
          "
        >
          <div
            class="sc-design-text-3 section-bloc current-location-bloc"
            (click)="onPickUserAddress()"
          >
            <sc-icon name="geoloc"></sc-icon>
            <span>{{
              'ChoseNewAddressBottomSheet.currentLocation' | translate
            }}</span>
          </div>
          <p class="sc-design-text-4 geoloc-hint">
            {{ 'ChoseNewAddressBottomSheet.enableGeolocHint' | translate }}
          </p>
        </button>
      </section>

      <mat-divider></mat-divider>
      <section *ngIf="userAddress">
        <button
          class="sc-design-text-3 section-bloc selected-address-bloc"
          (click)="onCancel()"
        >
          <span class="selected-address">
            <sc-icon
              name="map_location"
              specificName="chose-new-address-bottom-sheet-localisation"
            ></sc-icon>
            <span>{{ userAddress }}</span>
          </span>
        </button>
      </section>
    </div>
  `,
})
export class ChoseNewAddressBottomSheetComponent {
  @Input() userAddress: string;

  @Output() cancelEvent = new EventEmitter<void>();
  @Output() pickUserPositionEvent = new EventEmitter<GeoCoordinates>();
  @Output() choseAutoCompleteAddressEvent = new EventEmitter<void>();

  constructor(private readonly translator: TranslatorService) {}

  onChoseNewAddress(): void {
    this.choseAutoCompleteAddressEvent.emit();
  }

  onCancel(): void {
    this.cancelEvent.emit();
  }

  onPickUserAddress(): void {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const geoCodeData: GeoCoordinates = {
            lat: position.coords.latitude,
            lon: position.coords.longitude,
          };

          this.pickUserPositionEvent.emit(geoCodeData);
        },
        (err) => {
          alert(
            this.translator.getInstantTranslation(
              'ChoseNewAddressBottomSheet.geolocRefusedAlert'
            ) +
              '  ' +
              err.message
          );
        }
      );
    } else {
      alert(
        this.translator.getInstantTranslation(
          'ChoseNewAddressBottomSheet.geolocNoSupportedAlert'
        )
      );
    }
  }
}
